import { useCallback, useEffect, useState } from 'react';

export function useNavBlockerProvider() {
    const [ blockers, setBlockers ] = useState<Set<string>>(() => new Set<string>());
    const isBlocked = blockers.size > 0;

    const setBlocked = useCallback((id: string, isBlocked: boolean) => {
        setBlockers((prev) => {
            if (isBlocked) {
                return new Set([ ...prev, id ]);
            } else {
                const newSet = new Set(prev);
                newSet.delete(id);
                return newSet;
            }
        });
    }, [ setBlockers ]);

    useEffect(() => {
        if (isBlocked) {
            window.onbeforeunload = (ev: BeforeUnloadEvent) => {
                ev.returnValue = 'Máte neuložené změny. Opravdu chcete odejít z této stránky?';
                return '';
            };
        } else {
            window.onbeforeunload = null;
        }

        return () => {
            window.onbeforeunload = null;
        };
    }, [ isBlocked ]);  

    return {
        blockers,
        isBlocked,
        setBlocked
    };
}
